/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const web = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.58 14.795C5.633 13.406 5 10.883 5 8s.633-5.406 1.58-6.795m2.92 0c.947 1.389 1.58 3.912 1.58 6.795s-.633 5.406-1.58 6.795M1.46 5.5A6.984 6.984 0 0 0 1 8c0 .88.163 1.724.46 2.5m0-5a7.003 7.003 0 0 1 13.08 0m-13.08 0h13.08m0 0c.297.776.46 1.62.46 2.5 0 .88-.163 1.724-.46 2.5m0 0a7.003 7.003 0 0 1-13.08 0m13.08 0H1.46"
    />
  </svg>
)
export default web
